import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button, ItemIcon } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { KEY_COMPETITORS_ICON_OVERLAP_PX } from "./KeyCompetitorsChip.constants";

export const KeyCompetitorsChipButton = styled(Button)`
    && {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        margin-left: 8px;
        padding: 4px 14px 4px 6px;
        border: none;
        border-radius: 6px;
        background: ${colorsPalettes.blue[50]};
        box-shadow: none;
        cursor: pointer;
    }

    &&:hover,
    &&:active {
        background: ${colorsPalettes.blue[50]};
        box-shadow: none;
    }
`;

export const IconStack = styled(Flex).attrs({
    inline: true,
    alignItems: "center",
})``;

export const StackedIcon = styled(ItemIcon)<{ $hasOffset: boolean }>`
    flex-shrink: 0;
    ${({ $hasOffset }) => ($hasOffset ? `margin-left: -${KEY_COMPETITORS_ICON_OVERLAP_PX}px;` : "")}
`;
